import React, { useEffect, useState } from "react";
import "../../Styles/Form/ResponsesTableView.css";
import threeDotT from "../../Assets/threeDotT.png";
import close from "../../Assets/closeIcon.svg";
import { useParams } from "react-router-dom";
import axios from "axios";
import caret_down_icon from "../../Assets/caret-down_icon.svg";
import {
  CheckBox,
  CheckBoxGrid,
  DateAndTime,
  DateQuestion,
  Document,
  Dropdown,
  Email,
  GridBox,
  LineScale,
  Location,
  MultipleChoice,
  Name,
  Number,
  ParagraphAnswer,
  Phone,
  ShortAnswer,
  Signature,
  Spinner,
  VAFileUpload,
  Website,
} from "./TableViewFormEntryQuestions/TableViewFormEntryQuestions";

const ResponsesTableView = ({
  isOpen,
  onClose,
  user,
  allUsers,
  handleSelectChange,
}) => {
  const [openDropdown, closeDropdown] = useState(false);

  const date = user.updatedAt === undefined ? "" : new Date(user.updatedAt);

  const options = { month: "short", day: "2-digit", year: "numeric" };
  const formattedDate = new Intl.DateTimeFormat("en-US", options).format(date);

  // Format the date
  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.slice(0, maxLength) + "...";
  };
  const maxLength = 20;

  if (!isOpen) return null;
  return (
    <div className="responses-table-view-overlay">
      <div className="responses-table-question">
        <div className="top-user-details">
          <div className="top_user-deails-container">
            <div
              className="top-bar-user-email"
              style={{ zIndex: 100 }}
              onClick={() => closeDropdown(!openDropdown)}
            >
              <p>{truncateText(user.email, maxLength)}</p>
              <img
                src={caret_down_icon}
                alt="caret-down_icon"
                className="dropdown-icon"
              />
              {openDropdown && (
                <ul className="dropdown-menu">
                  {allUsers.map((item, index) => (
                    <li
                      key={index}
                      onClick={() => handleSelectChange(item)}
                      className={`dropdown-item ${
                        item.userId === user.userId ? "active" : ""
                      }`}
                    >
                      {truncateText(item.email, maxLength)}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            {/* <p className="top-bar-user-email">00</p>
            <p> of</p>
            <p className="top-bar-user-email">02</p> */}
          </div>
          <div className="top-rightside">
            {/* <div>
              <img src={threeDotT} alt="threeDotT" />
            </div> */}
            <div>
              <img src={close} alt="close" onClick={onClose} />
            </div>
          </div>
        </div>
        <hr style={{ border: "1px solid #8493B2" }} />
        <div>
          <div className="user-email-container">
            <p>{truncateText(user.email, maxLength)}</p>
            <p>Update at {formattedDate}</p>
          </div>
        </div>
        <div className="answer_containers">
          {user.responsesAndQuestion.map((eachQuestion, qindex) => (
            <div key={qindex}>
              <AllQuestions eachQuestion={eachQuestion} index={qindex} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const AllQuestions = ({ eachQuestion, index }) => {
  return <div className="">{renderQuestions(eachQuestion, index)}</div>;
};

const renderQuestions = (eachQuestion, index) => {
  switch (eachQuestion.type) {
    case "Short Answer":
      return <ShortAnswer question={eachQuestion} index={index} />;
    case "Paragraph":
      return <ParagraphAnswer question={eachQuestion} index={index} />;
    case "Name":
      return <Name question={eachQuestion} index={index} />;
    case "Phone":
      return <Phone question={eachQuestion} index={index} />;
    case "Multiple Choice":
      return <MultipleChoice question={eachQuestion} index={index} />;
    case "Check box":
      return <CheckBox question={eachQuestion} index={index} />;
    case "Email":
      return <Email question={eachQuestion} index={index} />;
    case "Number":
      return <Number question={eachQuestion} index={index} />;
    case "Line Scale":
      return <LineScale question={eachQuestion} index={index} />;
    case "Date":
      return <DateQuestion question={eachQuestion} index={index} />;
    case "Multiple Choice grid":
      return <GridBox question={eachQuestion} index={index} />;
    case "Check box grid":
      return <CheckBoxGrid question={eachQuestion} index={index} />;
    case "Date - Time":
      return <DateAndTime question={eachQuestion} index={index} />;
    case "Website":
      return <Website question={eachQuestion} index={index} />;
    case "Spinner":
      return <Spinner question={eachQuestion} index={index} />;
    case "Dropdown":
      return <Dropdown question={eachQuestion} index={index} />;
    case "Signature":
      return <Signature question={eachQuestion} index={index} />;
    case "Audio/Video Upload":
      return <VAFileUpload question={eachQuestion} index={index} />;
    case "File Upload":
      return <Document question={eachQuestion} index={index} />;
    case "Location":
      return <Location question={eachQuestion} index={index} />;
    // case "Ratings":
    //   return <Ratings question={eachQuestion} index={index} />;
    // case "Multiple Choice Image":
    //   return <MultipleChoiceImage question={eachQuestion} index={index} />;
    default:
      return null;
  }
};

export default ResponsesTableView;
